let chart = null;

export function initCharts() {
    // Initialize any charts here
}

export function createChart(amortizationBalances, compareData, compareLabel, labels) {
    let ctx = document.getElementById('principalComparisonChart').getContext('2d');

    // Add the final month when all debt is paid off
    compareData.push(0);
    amortizationBalances.push(0);
    labels.push(labels[labels.length - 1] + 1);

    if (!chart) {
        // Create the chart if it doesn't exist
        chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Current Mortgage',
                        data: amortizationBalances,
                        backgroundColor: 'rgb(75, 192, 192)',
                        borderColor: 'rgb(75, 192, 192)',
                        tension: 0.1
                    },
                    {
                        label: compareLabel,
                        data: compareData,
                        backgroundColor: 'rgb(255, 99, 132)',
                        borderColor: 'rgb(255, 99, 132)',
                        tension: 0.1
                    }
                ]
            },
            options: {
                responsive: true,
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Payment Number'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Principal Balance ($)'
                        },
                        ticks: {
                            callback: function(value, index, values) {
                                return '$' + value.toLocaleString();
                            }
                        }
                    }
                },
                plugins: {
                    title: {
                        display: true,
                        text: 'Principal Balance Over Time',
                        font: {
                            size: 28,
                        }
                    }
                }
            }
        });
    } else {
        // Update existing chart
        chart.data.labels = labels;
        chart.data.datasets[0].data = amortizationBalances;
        chart.data.datasets[1].data = compareData;
        chart.data.datasets[1].label = compareLabel;
    }

    chart.update();
}
